<ng-container *ngIf="connectService?.isColumnConfigurationEnabled() || false">
  <div class="section">
    <div ngbAccordion class="ngb-accordion-default contextbar-accordion" [animation]="false" >
      <div ngbAccordionItem (shown)="toggleChooser()" (hidden)="toggleChooser()">
        <div ngbAccordionHeader>
          <button ngbAccordionButton>
            <span>
              <b>{{ title | translate }}</b>
              <qpoint-icon class="contextbar-icon" icon="angle-right"></qpoint-icon>
            </span>
          </button>
        </div>
        <div ngbAccordionCollapse>
        </div>
      </div>
    </div>
  </div>
  <qpoint-grid-sticky-chooser style="visibility: collapse;" #chooser></qpoint-grid-sticky-chooser>
</ng-container>
